import { render, staticRenderFns } from "./PricingPlans.vue?vue&type=template&id=0ec64d8b&scoped=true"
import script from "./PricingPlans.vue?vue&type=script&lang=ts"
export * from "./PricingPlans.vue?vue&type=script&lang=ts"
import style0 from "./PricingPlans.vue?vue&type=style&index=0&id=0ec64d8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec64d8b",
  null
  
)

export default component.exports